// GENERATED from backend/services/billMemory/core — do not edit; run backend/scripts/sync-bill-memory-core.js
/**
 * One stock-in can carry several bills (pages), each with its own vendor finding. Typed rows on it
 * and the vendor the screen shows use the one certain vendor the bills agree on: a page without a
 * clue does not disagree; the same vendor found by GSTIN on one page and by phone on another, or
 * through a "same vendor" pair, agrees (vendor_ids); two different certain vendors → none.
 */
function idsOf(v) {
  return (Array.isArray(v.vendor_ids) && v.vendor_ids.length ? v.vendor_ids : [v.vendor_id]).map(Number);
}

function agreedVendor(vendors) {
  const certain = (Array.isArray(vendors) ? vendors : []).filter((v) => v && v.certain && v.vendor_id);
  if (!certain.length) return null;
  const first = Number(certain[0].vendor_id);
  return certain.every((v) => idsOf(v).includes(first)) ? certain[0] : null;
}

export { agreedVendor };
